<template>
		
	<dl class="opport-screen bdbe">
		<dt class="fl">{{curWebsite.keyword}}机会</dt>
		<dd class="fl"> 
			<span :key="index" v-for="(item,index) in curNavlist" @click="routerself(item.url)" v-show="item.title!=''" :class="tabCode == item.code ?'a-screen current':'a-screen'" >{{item.title}}</span>  
			<video-teaching :type="2" ></video-teaching>
		</dd>
	</dl>
</template> 
<script>
	export default {
		name: 'dynamicNav',
		props:{ 
			tabCode:{
				type:String,
				default:"tzxm",
			}
		},
		data: function(){
			return{ 
					showmoreList:false,curWebsite:this.$api.getWebsiteType(),  
					//招商 研究(治理) 园区 信贷四个不同的header
					curNavlist:[
						{type:1,code:'tzxm',title:'投资项目动态',url:'/investdynamic'},
						{type:2,code:'ndxm',title:'拿地项目动态',url:"/landdynamic",},
						// 
						{type:6,code:'rzxm',title:'融资项目动态',url:"/financingdynamic",},
						{type:3,code:'qytz',title:"",url:"/enterpriseNews1",},
						// {type:4,code:'zsqb',title:'招商情报动态',url:"/timeinfor",},
						{type:5,code:'qyzx',title:'企业资讯动态',url:"/enterpriseNews",},  
						{type:6,code:'cyzx',title:'产业资讯动态',url:"/industryInvestment",}
						],
					 
		 
			};
		},
		created() {
			var marketStr=this.curWebsite.type== 4 || this.curWebsite.type== 2;//信贷和治理
			// this.curNavlist[4].title=marketStr?'市场情报动态':'招商情报动态'; 
		},
		watch:{
			tabCode:{
				handler(newVal,oldVal){ 
					var allNavList=this.curNavlist;
					for(var i=0;i<allNavList.length;i++){
						if(this.tabCode == allNavList[i].code){ 
							document.title=this.curWebsite.name+"-"+allNavList[i].name;
							if(allNavList[i].type == 'b'){
								this.showmoreList=true;
							}
						}
					} 
					this.type=newVal; 
				}
			}
			
			
		},
		mounted() {
		var allNavList=this.curNavlist;
		for(var i=0;i<allNavList.length;i++){
			if(this.tabCode == allNavList[i].code){ 
				document.title=this.curWebsite.name+"-"+allNavList[i].name;
				if(allNavList[i].type == 'b'){
					this.showmoreList=true;
				}
			}
		} 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
</style>